'use strict';

const { h } = require('phy');
const { Translate } = require('@grpn/preact-l10n');

const MerchantOffersRow = require('./merchant-offers-row');

function filterOffers(offers) {
  return offers
    .filter(
      ({ offerTitle, financialTerms }) =>
        !!offerTitle && financialTerms.length === 0
    )
    .slice(0, 6)
    .reverse();
}

function MerchantOffersTable({ offers = [] }) {
  const offersList = filterOffers(offers);

  if (!offersList.length) {
    return h(
      'p.offers-table-empty',
      h(Translate, 'modules.merchant.NoExpiredOffers')
    );
  }

  return h(
    'table.offers-table',
    h(
      'thead',
      h('tr', [
        h(
          'th.offers-table-heading',
          h(Translate, 'modules.merchant.AnswerBoxCodeTitleHeading')
        ),
        h(
          'th.offers-table-heading',
          h(Translate, 'modules.merchant.AnswerBoxDiscountTypeHeading')
        ),
        h(
          'th.offers-table-heading',
          h(Translate, 'modules.merchant.AnswerBoxExpiryDateHeading')
        ),
      ])
    ),
    h('tbody', offersList.map(MerchantOffersRow))
  );
}

module.exports = MerchantOffersTable;
